module.exports = __webpack_public_path__ + "static/assets/c010daca9c3de0d95f304e3c64c120c0.png";